import React, { useMemo } from 'react';
import { useAllCommentsForRiskAssessmentQuery } from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useAtomValue } from 'jotai';
import { selectedRiskTab } from '../state/atoms';
import CommentsList from './CommentList';

type Props = {
  selectedAssemblyId: string;
};

const CommentsContainer = ({ selectedAssemblyId }: Props) => {
  const structureId = useGetStructureId();
  const type = useAtomValue(selectedRiskTab);

  const { data, loading } = useAllCommentsForRiskAssessmentQuery({
    variables: {
      input: { structureId, referenceId: selectedAssemblyId, collectionName: 'assembly', type },
    },
  });

  const comments = useMemo(() => data?.allComments || [], [data]);

  return <CommentsList comments={comments} loading={loading} />;
};

export default CommentsContainer;
